import FlowbiteIconComponent from '../flowbite-icon/flowbiteIcon'

export const SuccessPage: React.FC = () => {
  return (
    <div className="h-screen flex flex-col items-center text-center">
      <div className="flex mr-1">
        <FlowbiteIconComponent iconType="CheckCircle" iconClassName="text-feYellow min-w-[70px] min-h-[70px]" />
      </div>
      <div className="text-[30px] font-bold leading-[45px] mt-[25px]">
        Thank you for your support

      </div>
      <div className="text-[16px] text-center mb-[10px] font-medium leading-[24px] my-4">
        <div className="mb-3">Your donation inquiry has been submitted</div>
      </div>
    </div>
  )
}